/**
 * 写真を送る前に端末で縮める（長辺 1024px の JPEG）。
 * キャンバスに描き直すので、位置情報などの EXIF は送らない。⚠️ 縮める前の写真をそのまま送らない（サーバは 1MB まで）。
 * `createImageBitmap(..., { imageOrientation: "from-image" })` で向きを直す。blob: URL を作らない（CSP の img-src は self と data: と kalori の公開画像だけ）。
 */
const MAX_SIDE = 1024;
const MAX_BASE64 = 1_300_000;

export async function toJpeg(file: File): Promise<{ base64: string; dataUri: string }> {
  let bitmap: ImageBitmap;
  try {
    bitmap = await createImageBitmap(file, { imageOrientation: "from-image" });
  } catch {
    throw new Error("この写真は読み込めませんでした。JPEG か PNG の写真でお試しください。");
  }
  const scale = Math.min(1, MAX_SIDE / Math.max(bitmap.width, bitmap.height));
  const canvas = document.createElement("canvas");
  canvas.width = Math.max(1, Math.round(bitmap.width * scale));
  canvas.height = Math.max(1, Math.round(bitmap.height * scale));
  const ctx = canvas.getContext("2d");
  if (!ctx) throw new Error("このブラウザでは写真を処理できませんでした。");
  ctx.drawImage(bitmap, 0, 0, canvas.width, canvas.height);
  bitmap.close();
  for (const quality of [0.85, 0.7, 0.55]) {
    const dataUri = canvas.toDataURL("image/jpeg", quality);
    const base64 = dataUri.slice(dataUri.indexOf(",") + 1);
    if (base64.length <= MAX_BASE64) return { base64, dataUri };
  }
  throw new Error("写真を小さくできませんでした。別の写真でお試しください。");
}
